import { Autocomplete, Box, Breadcrumbs, Button, CircularProgress, Grid2, MenuItem, Paper, TextField, Typography } from "@mui/material";
import Wrapper from "../components/Wrapper"
import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { addService, getService, updateService } from "../services/services";
import { enqueueSnackbar } from "notistack";

const MODALITIES = [
  {
    'name': 'Vaastu Healing',
    'category': ['Body']
  },
  {
    'name': 'Theta Healing',
    'category': ['Soul']
  },
  {
    'name': 'Tantra',
    'category': ['Soul']
  },
  {
    'name': 'Spirit Release Therapy',
    'category': ['Soul']
  },
  {
    'name': 'Sound Healing',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Somatic & Trauma Healing',
    'category': ['Mind']
  },
  {
    'name': 'Shamanism',
    'category': ['Soul']
  },
  {
    'name': 'Reiki',
    'category': ['Body']
  },
  {
    'name': 'Redikall Healing',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Quantum Healing',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Psychic Readings',
    'category': ['Mind']
  },
  {
    'name': 'Pranic Healing',
    'category': ['Body']
  },
  {
    'name': 'Past Life Regression (PLR)',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Nuero Linguistic Programming (NLP)',
    'category': ['Mind']
  },
  {
    'name': 'Meditation',
    'category': ['Mind', 'Soul']
  },
  {
    'name': 'Life Between Lives',
    'category': ['Soul']
  },
  {
    'name': 'Jikiden Reiki',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Hypnotherapy',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Healing Through Prayer',
    'category': ['Soul']
  },
  {
    'name': 'Healing Gems',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Heal Your Life',
    'category': ['Mind']
  },
  {
    'name': 'Family Constellations',
    'category': ['Mind']
  },
  {
    'name': 'Emotional Freedom Technique (EFT)',
    'category': ['Mind']
  },
  {
    'name': 'Dowsing',
    'category': ['Body']
  },
  {
    'name': 'Carnio Sacral Therapy',
    'category': ['Body']
  },
  {
    'name': 'Chakra Balancing',
    'category': ['Mind', 'Body']
  },
  {
    'name': 'Aura Healing',
    'category': ['Mind']
  },
  {
    'name': 'Angel Healing',
    'category': ['Soul']
  },
  {
    'name': 'Tarot Card Reading',
    'category': ['Mind']
  },
  {
    'name': 'Switch Words',
    'category': ['Mind']
  },
  {
    'name': 'Dragon Energy',
    'category': ['Mind', 'Body', 'Soul']
  },
  {
    'name': 'Akashic Records',
    'category': ['Soul']
  }
];

const CURRENCIES = [
  'USD',
  'GBP',
  'EURO',
  'INR',
  'YEN',
  'AED'
]

const blank_obj = {
  name: '',
  price: '',
  price_per: '',
  type: [],
  modality: '',
  description: '',
  currency: '',
  booking_mode: ''
}

const AddService = () => {

  const [details, set_details] = useState(blank_obj)

  const [is_saving, set_is_saving] = useState(false);

  const [is_edit, set_is_edit] = useState(false);

  const [modality_value, set_modality_value] = useState(null);

  const params = useParams();

  const id = params.id;

  useEffect(() => {
    if (id) {
      set_is_edit(true);
      getData();
    }
    // eslint-disable-next-line
  }, [id])

  const getData = async () => {
    const { data } = await getService({ id: id });

    const type = Array.isArray(data.data.type) ? data.data.type : [];

    if (data) {
      set_details({
        name: data.data.name,
        price: data.data.price,
        currency: data.data.currency,
        price_per: data.data.price_per,
        type: type,
        modality: data.data.modality,
        description: data.data.description,
        booking_mode: data.data.booking_mode
      })

      set_modality_value({
        name : data.data.modality,
        category : type
      })
    }
  }

  const handleDetailChange = ({
    key,
    value
  }) => {
    set_details({
      ...details,
      [key]: value
    })
  }

  const handleSave = async () => {
    set_is_saving(true);

    if (is_edit) {
      const { data, error } = await updateService({
        data: details,
        id: id
      })

      set_is_saving(false);

      if (data) {
        if (data.success) {
          enqueueSnackbar('Service updated successfully !', {
            variant: 'success'
          })
        } else {
          enqueueSnackbar('Error while updating service !', {
            variant: 'error'
          })
        }
      }
      if (error) {
        enqueueSnackbar('Error while updating service !', {
          variant: 'error'
        })
      }
    }
    else {
      const { data, error } = await addService({
        data: details
      })

      set_is_saving(false);

      if (data) {
        if (data.success) {
          enqueueSnackbar('Service added successfully !', {
            variant: 'success'
          })

          set_details(blank_obj)
        } else {
          enqueueSnackbar('Error while adding service !', {
            variant: 'error'
          })
        }
      }
      if (error) {
        enqueueSnackbar('Error while adding service !', {
          variant: 'error'
        })
      }
    }
  }

  // const handleChangeType = (event) => {

  //   const type = event.target.value;
  //   const types = [...details.type];
  //   const type_index = types.indexOf(type);

  //   if(type_index < 0){
  //     types.push(type)
  //   }
  //   else{
  //     types.splice(type_index, 1);
  //   }

  //   handleDetailChange({
  //     key : 'type',
  //     value : types
  //   })
  // }

  const handleChangeModality = (event, value) => {
    set_modality_value(value);
    
    set_details({
      ...details,
      modality : value ? value.name : '',
      type : value ? value.category : []
    })
  }

  return (
    <Wrapper>
      <Paper
        sx={{
          padding: '10px 20px',
          marginBottom: '20px'
        }}

        elevation={4}
      >
        <Breadcrumbs>
          <Link to='/services' className="link">
            Services
          </Link>
          <Typography>
            Add New
          </Typography>
        </Breadcrumbs>
      </Paper>

      <Paper
        elevation={4}
        sx={{
          padding: '20px',
          marginBottom: '20px'
        }}
      >
        <Grid2
          container
          spacing={2}
        >
          <Grid2 size={4}>
            <TextField
              label="Name"
              fullWidth
              name='name'
              value={details.name}
              onChange={(event) => handleDetailChange({
                key : 'name',
                value : event.target.value
              })}
            />
          </Grid2>
          <Grid2 size={4}>
            <Box
              display='flex'
              alignItems='center'
              gap='10px'
            >
              <TextField
                label='Price'
                sx={{
                  flexGrow: 1
                }}
                name='price'
                value={details.price}
                onChange={(event) => handleDetailChange({
                  key : 'price',
                  value : event.target.value
                })}
              />
              <TextField
                select
                label='Currency'
                sx={{
                  width: '150px'
                }}
                name='currency'
                value={details.currency}
                onChange={(event) => handleDetailChange({
                  key : 'currency',
                  value : event.target.value
                })}
              >
                <MenuItem value='' disabled> Select Currency </MenuItem>
                {
                  CURRENCIES.map((currency) => {
                    return (
                      <MenuItem
                        value={currency}
                        key={`CURRENCY-${currency}`}
                      >
                        {currency}
                      </MenuItem>
                    )
                  })
                }
              </TextField>
              /
              <TextField
                select
                sx={{
                  width: '120px'
                }}
                name='price_per'
                value={details.price_per}
                onChange={(event) => handleDetailChange({
                  key : 'price_per',
                  value : event.target.value
                })}
              >
                <MenuItem value="Hour"> Hour </MenuItem>
                <MenuItem value="Session"> Session </MenuItem>
              </TextField>
            </Box>
          </Grid2>
          <Grid2 size={4}>
            <TextField
              select
              fullWidth
              label="Service Mode"
              name='booking_mode'
              value={details.booking_mode}
              onChange={(event) => handleDetailChange({
                key : 'booking_mode',
                value : event.target.value
              })}
            >
              <MenuItem value="" disabled> Select Mode </MenuItem>
              <MenuItem value="Online"> Online </MenuItem>
              <MenuItem value="Offline"> Offline </MenuItem>
            </TextField>
          </Grid2>
          {/* <Grid2 size={4}>
            <Box
              display='flex'
              alignItems='center'
              flexWrap='wrap'
              sx={{
                gap: '10px',
                height: '100%'
              }}
            >
              <FormLabel> Type :</FormLabel>
              <FormControlLabel
                label="Mind"
                control={
                  <Checkbox
                    checked = {details.type.includes('Mind')}
                    onChange={handleChangeType}
                    value='Mind'
                  />
                }
              />
              <FormControlLabel
                label="Body"
                control={
                  <Checkbox
                    checked = {details.type.includes('Body')}
                    onChange={handleChangeType}
                    value='Body'
                  />
                }
              />
              <FormControlLabel
                label="Soul"
                control={
                  <Checkbox
                    checked = {details.type.includes('Soul')}
                    onChange={handleChangeType}
                    value='Soul'
                  />
                }
              />
            </Box>
          </Grid2> */}
          <Grid2 size={4}>

            <Autocomplete
              options={MODALITIES}
              getOptionLabel={(option) => option.name}
              onChange={handleChangeModality}
              value={modality_value}

              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Modality"
                />
              )}

              renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                
                return (
                  <Box
                    key={key}
                    component="li"
                    {...optionProps}
                    flexDirection='column'
                    alignItems='flex-start'

                    sx={{
                      alignItems : 'flex-start !important'
                    }}
                  >
                    {option.name}
                    <Typography
                      component={'div'}
                      variant="caption"
                      color="textSecondary"
                    >
                      {
                        option.category.join(', ')
                      }
                    </Typography>
                  </Box>
                );
              }}
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              fullWidth
              rows={5}
              multiline
              label='Description'
              name='description'
              value={details.description}
              onChange={(event) => handleDetailChange({
                key : 'description',
                value : event.target.value
              })}
            />
          </Grid2>
        </Grid2>

      </Paper>

      <Paper
        elevation={4}
        sx={{
          padding: '10px 20px',
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={
            is_saving ||
            !Boolean(details.name) ||
            !Boolean(details.price) ||
            !Boolean(details.currency) ||
            !Boolean(details.price_per) ||
            !Boolean(details.booking_mode) ||
            !Boolean(details.type.length) ||
            !Boolean(details.modality) ||
            !Boolean(details.description)
          }
        >
          {is_saving ? <CircularProgress /> : 'Save'}
        </Button>
      </Paper>
    </Wrapper>
  )
}

export default AddService;